import React, { useEffect, useState } from "react";
import "./index.scss";
import {Link, useLocation, useNavigate} from "react-router-dom";
import Button from "../../UI/Button";
import useGetNotificationsApi from "../../Global/Api/Notifications/getNotificationsApi";
import {useSelector} from "react-redux";
import moment from "moment";

export default function Header({ title, showFull, onboarding }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [showNotification, setShowNotification] = useState(false);
  const getNotifications = useGetNotificationsApi();
  const getUnreadNotifications = useGetNotificationsApi();
  const {notifications, unreadNotifications} = useSelector((state) => state?.rootReducer.techsbookSlice);
  const [page, setPage] = useState(1);
  const [isClicked, setIsClicked] = useState(false);
  const accountIndex = useSelector(
    (state) => state.rootReducer.techsbookSlice.userData
  );
  useEffect(() => {
    return window.addEventListener("click", (e) => {
      if (
        e.target.closest(".header__notification") === null &&
        e.target.closest(".header__notifdrop") === null
      ) {
        setShowNotification(false);
      }
    });
  }, [location]);

  const formatParams = () => {
    const params = new URLSearchParams();
    params.append('page', String(page));
    params.append('perPage', String(6));
    return params
  }

  useEffect(() => {
    if (accountIndex?.registration_completed) {
      getNotifications.get(formatParams);
      getUnreadNotifications.get(formatParams);
    }
  }, [location, accountIndex])

  const renderNotifications = () => {
    return notifications?.data?.map(item => (
      <Link onClick={() => {
        if (!isClicked) {
          setIsClicked(true)
          localStorage.setItem("jobId", item?.job_id);
          localStorage.setItem("jobTitle", item?.title);
          if(!item?.is_read) {
              getNotifications.mark({
                  params: item?.id,
                  body: {}
              })
          }
          setShowNotification(false)
          setTimeout(() => {
            getNotifications.get(formatParams)
            setIsClicked(false)
          }, 800)
        }
      }}
            to={`/jobs/${item?.job_id}`}
            key={item?.id} className="header__notifdrop-item">
        <div className="header__notifdrop-left">
          <div className="header__notifdrop-avatar">
            <img src="/assets/icons/complete-job.svg" alt="" />
          </div>
          <div className="header__notifdrop-info">
            <p className="header__notifdrop-name">
              {item?.title}
            </p>
            <p className="header__notifdrop-desc">
              {item?.description}
            </p>
            <p className="header__notifdrop-time">{moment(item?.created_at).format("YYYY-MM-DD hh:mm A")}</p>
          </div>
        </div>
        <div className="header__notifdrop-right">
          {!item?.read_at && (<div className="header__notifdrop-dot"></div>)}
        </div>
      </Link>
    ))
  }

  return (
    <div className="header">
      {onboarding && (
        <div className="header__logo">
          <img src="/assets/images/logo.svg" alt="techsbook" />
        </div>
      )}
      {location?.pathname === '/notifications' && (
        <div className="header__back-wrapper">
          <div onClick={() => {
            navigate(-1);
          }} className='header__backBtn'>
            <img src="/assets/icons/back-arrow.svg" alt=""/>
          </div>
          <p className="header__title">{title}</p>
        </div>
      )}
      {location?.pathname !== '/notifications' && (
        <p className="header__title">{title}</p>
      )}
      {showFull && (
        <div className="header__right">
          <div
            onClick={() => {
              setShowNotification(!showNotification);
            }}
            className="header__notification"
          >
            {
                unreadNotifications?.data?.length ?
                (<span className="header__notification-dot"></span>) : null
            }
            <span>
              <img src="/assets/icons/notification.svg" alt="notification" />
            </span>
          </div>
          {showNotification && (
            <>
              <div className="header__notifdrop">
                <p className="header__notifdrop-title">Notifications</p>
                <div className="header__notifdrop-list">
                  {notifications?.data?.length === 0 ? (
                    <div className="notifications__empty">
                      <div>
                        <img src="/assets/images/noti-empty.svg" alt=""/>
                      </div>
                      <p className="notifications__empty-text">No Notifications</p>
                    </div>
                  ) : renderNotifications()}
                </div>
                {notifications?.totalPage > 1 && (<div className="header__notifdrop-bottom">
                  <Link to={'/notifications'} className="header__notifdrop-btn">See All Notifications</Link>
                </div>)}
              </div>
            </>
          )}
          <div className="header__separator"></div>
          <div className="header__btn">
            <Button
              onClick={() => {
                navigate("/schedule");
              }}
              text="Schedule tech"
            />
          </div>
        </div>
      )}
    </div>
  );
}
